import { IZIndex } from '../types';

export const zIndex: IZIndex = {
  max: 999900,
  overlay: 400,
  top: 300,
  normal: 200,
  below: 100,
};
